<template>
    <div class="loto" v-if="!isLoading">
        <TitleCommon :title="$store.state.cart.games.name" :isShowButtonBack="true" />
        <NumbersLoto />
    </div>
</template>
<script>
import TitleCommon from '@/components/common/title/index.vue';
import NumbersLoto from '@/components/loto/numbers/index.vue';
import { isObjEmpty } from '@/utils/utils';

export default {
    components: { TitleCommon, NumbersLoto },
    data() {
        return {
            isLoading: true,
        };
    },
    created() {
        if (isObjEmpty(this.$store.state.cart.events)) {
            const query = this.$route.query;
            this.$router.push({ path: '/loto-590', query });
        } else {
            this.isLoading = false;
        }
    },
};
</script>

<style lang="scss">
@import '@/public/scss/loto/loto.scss';
</style>
